import { find } from 'lodash'
import { getSelected } from 'state/customize/selectors'

function getDiscountHints(state){
  const grip = getSelected(state, 'grip');
  const headCover = getSelected(state, 'headCover');
  const buyAPutter = getSelected(state, 'buyAPutter');
  const restoration = getSelected(state, 'restorationType');
  const reshaft = getSelected(state, 'reshaft'); 

  return {
    hasPremium : grip && grip.isPremium && headCover && headCover.isPremium,
    restoration: !!restoration,
    reshaft: reshaft && !reshaft.keepShaft,
    buyAPutter: !!buyAPutter
  } 
}

export function getPartPrice(state, part, discountHints, overrideSelection){ 
  const selection = overrideSelection || getSelected(state, part); 
  if (!discountHints) { 
    discountHints = getDiscountHints(state) 
  }

  switch(part){ 
    case 'paintFill': 
      return (selection && !discountHints.restoration && !discountHints.buyAPutter) ?
        selection.price || 0 :
        0;
    case 'reshaft':
    case 'headCover':
      return (discountHints.restoration) ?
        (selection && selection.discountPrice) || 0 :
        (selection && selection.price) || 0;
    case 'authentication':
      return (discountHints.restoration) ?
        (selection && selection.discountPrice) || 0 :
        (selection && selection.price) || 0;
    case 'grip':
      return (discountHints.reshaft || discountHints.restoration) ?
          (selection && selection.discountPrice) || 0 :
          (selection && selection.price) || 0;
    default: 
      return (selection && selection.price) || 0;
  }
}

export default function getPrice(state) {
  let total = 0;

  const discountHints = getDiscountHints(state) 

  // Add restoration and finish prices
  total += getPartPrice(state, 'restorationType', discountHints);
  total += getPartPrice(state, 'finish', discountHints);

  // Add initials prices - $$ for each location used
  const initials = getSelected(state, 'initials');
  Object.keys(initials).forEach(initialsField => {
    const selected = initials[initialsField];
    const locationInfo = find(state.putter.initialsLocation, { label: initialsField });

    if (selected.characters && selected.characters.length > 0) {
      total += ((parseFloat(locationInfo.price) || 0) + (selected.personalizationStyle.price || 0));
    }
  });

  // Add stamps prices - if Pro Platinum and customshop stamp, 1 freebie
  let usedFreeStamp = false;
  const isCustomShopStamp = function (stamp) { return stamp && stamp.id === 4; }
  const isProPlatinumFinish = function (finish) { return finish && !(finish.id === 2 || finish.id === 6); }

  const stamps = getSelected(state, 'stampSelections');
  stamps.filter(selection => selection.stamp).forEach(selection => {
    if (!usedFreeStamp && 
      isCustomShopStamp(selection.stamp) && 
      discountHints.restoration && isProPlatinumFinish(getSelected(state, 'finish'))) {
      usedFreeStamp = true;
    } else {
      total += parseFloat(selection.stamp.price) || 0;
    }
  });

  // Calculate top and flange line prices. If more than one line, use discount price. 
  if (!discountHints.buyAPutter){ 
    const topLine = getSelected(state, 'topLine');
    const sightDot = getSelected(state, 'sightDot');
    const flangeLine = getSelected(state, 'flangeLine');
    const numTopLines = (topLine && topLine.numberOfLines) || 0;
    const numSightDot = (sightDot && sightDot.numberOfLines) || 0;
    const numFlangeLines = (flangeLine && flangeLine.numberOfLines) || 0;
    const numLines = numTopLines + numSightDot + numFlangeLines;
    if (numLines > 0) {
      total += 30 + (20 * (numLines - 1));
    }
  }

  // If there isn't restoration or a premium accessory, charge for paintfill
  total += getPartPrice(state, 'paintFill', discountHints);

  // Add loft, lie, length prices. These are all currently zero. Logic is here in case that changes.
  total += getPartPrice(state, 'loft', discountHints);
  total += getPartPrice(state, 'lie', discountHints);
  total += getPartPrice(state, 'length', discountHints); 

  // If there's restoration, discount the reshaft and authentication
  // Otherwise, charge full price
  total += getPartPrice(state, 'reshaft', discountHints);
  total += getPartPrice(state, 'authentication', discountHints); 

  // Accessories
  total += getPartPrice(state, 'grip', discountHints);
  total += getPartPrice(state, 'shaftBand', discountHints); 
  total += getPartPrice(state, 'headCover', discountHints); 
  total += getPartPrice(state, 'buyAPutter', discountHints); 

  // Add prices for weight options
  total += getPartPrice(state, 'weight', discountHints); 
  total += getPartPrice(state, 'weightEngraving', discountHints); 
  total += getPartPrice(state, 'topWeight', discountHints); 
  total += getPartPrice(state, 'topWeightEngraving', discountHints); 

  // Add prices for the gotta-have-it accessories (possibly more than 1)
  getSelected(state, 'accessories').forEach(a => {
    total += a.price || 0;
  });

  return total;
}
